import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Memnoch the Devil",
  "description": "",
  "published": "2007-05-26T00:00:00.000Z",
  "redirect_from": ["/blog/memnoch-the-devil/swizec/203"],
  "categories": "review",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In `}<em parentName="p">{`Memnoch the Devil`}</em>{` Anne Rice comes at us again with her usual skill of storytelling and interesting events. The book is filled with unexpected twists and turns on the iminent road to disaster, which, for a fifth book in a series, is rather commendable. There are of course many little quirks and less surprising twists any fan of The Vampire Chronicles should know, but the book is probably acceptable even to a fresh mind.`}</p>
    <p>{`Lestat is again being his usual self and begins the book with being overly stressed out about something, claiming his life is in peril and being an overall pantsy. Granted it was the Devil who was chasing him, but for a vampire Lestat handles the whole affair rather girly while still bravely. Come to think, he really is an awesome character.`}</p>
    <p>{`The story itself was better than expected after the staleness of The Tale of the Body Thief, which was very similar to the earlier books. Memrnoch was a nice refreshing venture into more misterious aspects of life and death. The overall message of the book is something I cannot quite agree with. Rice was aiming at the fact that whatever a person does they inevitable help God in whatever his plans are and to me this is just a tad too biblical.`}</p>
    <p>{`Not saying there is anything wrong with religion, but one would expect better of a book about vampires and their relation to the devil.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      